import type { Account } from '@adtrackify/at-tracking-event-types';

import { resolveIncompleteSignupDestination } from '@/features/signup/helpers/resolve-incomplete-signup-destination';
import { buildCustomerHomePath } from '@/lib/navigation/post-auth-destination';
import { isAccountEffectivelyActive } from '@/lib/helpers/account/account';
import type {
  WorkspaceDestination,
} from '../types/resolve-workspace-destination-types';

export function resolveWorkspaceDestination(account: Account): WorkspaceDestination {
  if (isAccountEffectivelyActive(account)) {
    const pixelAccountId = account.pixels?.[0]?.accountId;
    return {
      path: buildCustomerHomePath(pixelAccountId),
      requiresPlanOrRecovery: false,
    };
  }

  const destination = resolveIncompleteSignupDestination([account], {
    userId: '',
    completedStep: 0,
    selectedAccountId: account.id,
  });

  return {
    path: destination.redirectTo,
    requiresPlanOrRecovery: true,
  };
}
